var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mx-4 mb-4"},[_c('div',{staticClass:"mb-3 mt-4",staticStyle:{"position":"relative"}},[_c('span',{staticClass:"main-title"},[_vm._v("RIDER SUMMARY |  ")]),_c('span',{staticClass:"submain-title"},[_vm._v("Rider report")]),_c('download-excel',{staticStyle:{"position":"absolute","top":"0px","right":"40px"},attrs:{"data":_vm.export_rider_format,"fields":{
          'No':  'No' ,
          'Rider status': 'status' ,
          'Rider name' : 'rider_name'   ,
          'Start date':  'rider_time_start'  ,
          'tel.' : 'rider_tel' ,
          'Service Food/Mes/Free' : 'serviceFoodMesFree'  ,
          'Revenue' : 'revenue' ,
          'Com. 20%' : 'com' ,
          'Net revenus' : 'net_revenue'  ,
          'Credit' : 'credit'  ,
          'Tax com' : 'tax_com',
         },"name":'RiderReport_'+_vm.search_config.datetime_start+'_to_'+_vm.search_config.datetime_end+'.xls'}},[_c('v-btn',{attrs:{"icon":""}},[_c('v-icon',{attrs:{"large":"","color":"black"}},[_vm._v("print")]),_vm._v(".xls\n      ")],1)],1),_c('download-excel',{staticStyle:{"position":"absolute","top":"0px","right":"150px"},attrs:{"type":"csv","data":_vm.export_rider_format,"fields":{
          'No':  'No' ,
          'Rider status': 'status' ,
          'Rider name' : 'rider_name'   ,
          'Start date':  'rider_time_start'  ,
          'tel.' : 'rider_tel' ,
          'Service Food/Mes/Free' : 'serviceFoodMesFree'  ,
          'Revenue' : 'revenue' ,
          'Com. 20%' : 'com' ,
          'Net revenus' : 'net_revenue'  ,
          'Credit' : 'credit'  ,
          'Tax com' : 'tax_com',
         },"name":'RiderReport_'+_vm.search_config.datetime_start+'_to_'+_vm.search_config.datetime_end+'.csv'}},[_c('v-btn',{attrs:{"icon":""}},[_c('v-icon',{attrs:{"large":"","color":"black"}},[_vm._v("print")]),_vm._v(".csv\n      ")],1)],1)],1),_c('searchRiderReport'),_c('riderReportList')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }